var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.layoutClass},[_vm._t("default"),_vm._v(" "),_c('layout-portal'),_vm._v(" "),_c('layout-portal',{attrs:{"name":"modals-sub"}}),_vm._v(" "),_c('layout-portal',{attrs:{"name":"modals-sub2"}}),_vm._v(" "),_c('layout-portal',{attrs:{"name":"submenus"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }